import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_7: FaireProductEntity = {
  token: "starter_collection_7",
  type: "product",
  name: "L'ap\u00e9ro 1000 Piece Puzzle",
  brandName: "Piecework",
  imageUrl: "",
  priceDollars: 36,
  msrpDollars: 72,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
